// React
import React from "react";
// Framework
import { usePortal } from "stack/core";
import { useStackDependency } from "stack/dependency";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const StorageProvider = ({ children }) => {
  // Framework
  const { storage } = usePortal();
  // Init
  useStackDependency(storage);
  // Render
  return <>{children}</>;
};

export { StorageProvider };
